module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/core-js/get-iterator.js
// module id = 1131
// module chunks = 168707334958949